// this is an autogenerated file from App/Account/Content/Tasks/mutation-update-task-stage.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks($task_id: uuid!, $stage_id: uuid!) {
  update_tasks_tasks_by_pk(
    pk_columns: { id: $task_id }
    _set: { stage_id: $stage_id }
  ) {
    id
  }
}

`